
export const SET_IS_COLLECT = 'SET_IS_COLLECT'
export const SET_IS_COLLECT_SERVICE = 'SET_IS_COLLECT_SERVICE'
export const COUNT = 'COUNT'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js